import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 9v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 17h.01" })
	]
});
const ForwardRef = forwardRef(SvgWarning);
export default ForwardRef;
